import { NextPageContext } from "next";
import absoluteUrl from "next-absolute-url";
import { AppContext } from "next/app";
import { apiSubdomain, endpoints, environment } from "v3/config";

export function getApiPathFromAbsolutePath(
  apiSubdomain: string,
  req?: NextPageContext["req"]
): string {
  const { protocol, host } = absoluteUrl(req);
  const hostWithoutFirstPart = host.split(".").slice(1).join(".");
  return `${protocol}//${apiSubdomain}.${hostWithoutFirstPart}`;
}

export function getApiEndpoint(req?: NextPageContext["req"]): string {
  const host = req?.headers.host;
  const env =
    // special dev configuration to allow all apps to run concurrently locally
    environment === "dev" && host
      ? `http://${host.replace("secure", "api").replace("3001", "4000")}`
      : endpoints.api;
  return env;
}

/**
 * Function which returns either path with subdomain (if apiSubdomain is present) or plain endpoints.api
 */
export function getBasePath(req?: NextPageContext["req"]): string {
  return apiSubdomain
    ? getApiPathFromAbsolutePath(apiSubdomain, req)
    : getApiEndpoint(req);
}

export function getGQLPath(req?: NextPageContext["req"]): string {
  return `${getBasePath(req)}/v3/graphql`;
}

export function isServerSide(appContext: AppContext): boolean {
  return !!(typeof window === "undefined" && appContext?.ctx?.res?.writeHead);
}

/**
 * Detects if the current request is in a Shipyard environment (PR preview)
 */
function isShipyardEnvironment(req?: NextPageContext["req"]): boolean {
  const host = req?.headers.host || "";
  return host.includes("shipyard.host");
}

/**
 * Extracts the tenant identifier from the request.
 * In Shipyard environments, reads from the pepdirect-override-tenant header set by nginx.
 * In other environments, falls back to the GraphQL path (subdomain-based routing).
 */
export function getTenantFromRequest(req?: NextPageContext["req"]): string {
  if (isShipyardEnvironment(req)) {
    return req?.headers["pepdirect-override-tenant"] as string;
  }
  // In production/staging, use the GraphQL path which includes subdomain routing
  return getGQLPath(req);
}
